<script setup lang="ts">
import type { Article, Articles } from '#shared/interfaces/pickup/article'
import { TRANSITION_SOURCE } from '#shared/constant/constant'
import type { SendNewcarSearch } from '@/interfaces/searchUsedCar'
import { postWindowBridge } from '@/utils/windowBridge'
import { buildAsyncDataKey } from '@/utils/asyncDataKey'

const { currentModelFlg } = defineProps<{
  currentModelFlg?: boolean
}>()
const route = useRoute()
const query = route.query
const carCd = route.params.id ? route.params.id.toString().split('_')[0] : ''

// 関連記事取得
const { data: relatedArticles } = await useFetch<Articles>(
  '/api/goola/getSearch',
  {
    key: buildAsyncDataKey('goola-articles', 'car', carCd ?? ''),
    cache: 'no-cache',
    query: {
      category: 'ART',
      car_id: carCd + '|',
    },
  }
)
const postList = computed<Array<Article>>(() => {
  const docs = relatedArticles.value?.docs
  return docs instanceof Array ? docs.slice(0, 3) : []
})
const postTotal = computed<number>(() => {
  const docs = relatedArticles.value?.docs
  return docs instanceof Array ? (relatedArticles.value?.res_total ?? 0) : 0
})

const nuxtApp = useNuxtApp()
const moveToRelatedPosts = () => {
  const eventName = currentModelFlg
    ? 'CatalogCurrentMdlTopArticleListMoreTap'
    : 'CatalogPastMdlTopArticleListMoreTap'
  nuxtApp.$sendEventGaTag(eventName)
  const url = `${config.public.MAGAZINE_URL}/cars/${carCd}|`
  if (query.transition_source === TRANSITION_SOURCE.newcar_search) {
    const sendNewcarSearch: SendNewcarSearch = {
      url: url,
    }
    if (
      postWindowBridge('transitionCatalogApp', JSON.stringify(sendNewcarSearch))
    )
      return
  }
  window.location.href = url
}
const config = useRuntimeConfig()
const sendMagazine = (magazineId: string) => {
  const eventName = currentModelFlg
    ? 'CatalogCurrentMdlTopArticleListTap'
    : 'CatalogPastMdlTopArticleListTap'
  nuxtApp.$sendEventGaTag(eventName)
  const url = `${config.public.MAGAZINE_URL}/magazine/${magazineId}`
  if (query.transition_source === TRANSITION_SOURCE.newcar_search) {
    const sendNewcarSearch: SendNewcarSearch = {
      url: url,
    }
    if (
      postWindowBridge('transitionCatalogApp', JSON.stringify(sendNewcarSearch))
    )
      return
  }
  window.location.href = url
}
</script>
<template>
  <div v-if="postList.length > 0">
    <div class="related-article-title">関連記事</div>
    <div class="contents">
      <div
        v-for="(post, index) in postList"
        :id="'post-item-' + index.toString()"
        :key="post.post_id"
        :class="[index === postList.length - 1 ? 'shadow-sm' : '']"
        class="container article-content"
        @click="sendMagazine(post.post_id.toString())"
      >
        <DatadisplayGlobalRelatedPostsCassette :post="post" />
      </div>
    </div>
    <div v-if="postTotal > 3" class="btn-area">
      <div class="btn-more-article shadow-sm rounded">
        <div class="btn-content">
          <div class="more-article" @click="moveToRelatedPosts()">
            関連記事をもっと見る
          </div>
          <div>
            <img src="@/assets/image/icon/arrow_right.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.contents {
  background-color: #ffffff;
}
.container {
  padding: 0;
}
.related-article-title {
  font-size: 20px;
  font-weight: bold;
  margin-left: 16px;
  margin-bottom: 20px;
  margin-top: 48px;
}
.btn-area {
  margin: 16px 16px 70px 16px;
}
.btn-more-article {
  display: flex;
  font-size: 12px;
  font-weight: bold;
  background: #ffffff;
  width: 100%;
  min-height: 38px;
}
.btn-content {
  display: flex;
  margin: 0 0 0 33%;
  align-items: center;
}
.more-article {
  margin-right: 53px;
  min-width: 150px;
  overflow-wrap: break-word;
}
.btn-more-article i {
  color: red;
}

.article-content {
  border-bottom: 1px solid #f1f1f1;
}
</style>
